module.exports = __webpack_public_path__ + "img/cookie-icon.327d394.svg";